import React, { useContext, useRef } from 'react'
import { Card, PageHeader, Row, Col, Tabs, Pagination, BackTop } from 'antd'
import { Loading } from '@guillotinaweb/react-gmi'
import { usePromise, getHost } from '../../utils'
import { ErpClientContext } from '../../services/erp'
import { OpinionForm } from './OpinionForm'
import { SelectLanguage } from './filters'

import './styles.css'

const { TabPane } = Tabs
const host = getHost('vinissimus.com')

function ProductLink({ grupo, nombre }) {
  const productUrl = `https://${host}/es/vino/${grupo}`

  return (
    <a href={productUrl} target="_blank" rel="noopener noreferrer">
      {nombre}
    </a>
  )
}

function UserLink({ id }) {
  const userUrl = `https://${host}/administracion/usuarios/ficha_usuario.html?id_usuario=${id}`

  return (
    <a href={userUrl} target="_blank" rel="noopener noreferrer">
      User
    </a>
  )
}

export function OpinionsGroup() {
  const statusTabs = {
    pend: 'Pending',
    npub: 'Not Published',
    publ: 'Published',
  }
  const erpService = useContext(ErpClientContext)
  const { data, status, setData } = usePromise(
    () => erpService.getOpinions('pend'),
    []
  )
  const { data: total, status: totalStatus } = usePromise(
    () => erpService.getTotalOpinions(),
    []
  )
  console.log(total)

  const currentTab = useRef()
  const initialData = useRef()
  if (!initialData.current) initialData.current = data
  if (!currentTab.current) currentTab.current = 'pend'

  async function changeTab(status) {
    console.log(status)
    initialData.current = await erpService.getOpinions(status)
    currentTab.current = status
    setData(initialData.current)
  }
  async function changePage(page, pageSize) {
    console.log(page, pageSize)
    initialData.current = await erpService.getOpinions(
      currentTab.current,
      page,
      pageSize
    )
    setData(initialData.current)
  }

  if ([status, totalStatus].includes('loading')) return <Loading />
  if ([status, totalStatus].includes('failed')) return 'error'

  return (
    <div className="opinions">
      <Row>
        <Col span={4}>
          <PageHeader title="Filters" />
        </Col>
        <Col span={20}>
          <PageHeader className="title" title="Opinions" />
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <SelectLanguage initialData={initialData.current} setData={setData} />
        </Col>
        <Col span={20}>
          <Tabs defaultActiveKey="pend" onChange={changeTab}>
            {Object.keys(statusTabs).map((statusTab) => (
              <TabPane tab={statusTabs[statusTab]} key={statusTab}>
                <Pagination
                  defaultCurrent={1}
                  total={total[statusTab]}
                  showSizeChanger={false}
                  onChange={changePage}
                />
                {data.map((op) => (
                  <Card
                    className="card"
                    key={op.id_opinion}
                    title={<ProductLink grupo={op.grupo} nombre={op.nombre} />}
                    extra={<UserLink id={op.zope_id} />}
                  >
                    <OpinionForm
                      {...op}
                      data={data}
                      setData={setData}
                      initialData={initialData}
                      statusTab={statusTab}
                    />
                  </Card>
                ))}
                <BackTop />
                <Pagination
                  defaultCurrent={1}
                  total={total[statusTab]}
                  showSizeChanger={false}
                  onChange={changePage}
                />
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>
    </div>
  )
}
